const ArticlesLoadMore = {
  init() {
    const selectors = {
      root: '[data-articles-load-more]',
      card: '.tvg-articles__card',
      button: '[data-articles-more]',
      lessButton: '[data-articles-less]',
    } as const

    document.querySelectorAll<HTMLElement>(selectors.root).forEach((root) => {
      const cards = Array.from(root.querySelectorAll<HTMLAnchorElement>(selectors.card))
      const button = root.querySelector<HTMLButtonElement>(selectors.button)
      const lessButton = root.querySelector<HTMLButtonElement>(selectors.lessButton)
      const pageSize = 8
      const totalPages = Math.max(1, Math.ceil(cards.length / pageSize))
      let page = 1

      const update = () => {
        const activeElement = document.activeElement
        cards.forEach((card, index) => {
          card.hidden = index >= page * pageSize
        })
        if (button) button.hidden = page >= totalPages
        if (lessButton) lessButton.hidden = page <= 1

        if (activeElement instanceof HTMLElement && root.contains(activeElement) && activeElement.closest('[hidden]')) {
          const control = page > 1 ? lessButton : button
          control?.focus({ preventScroll: true })
        }
      }

      const restorePage = () => {
        const url = new URL(window.location.href)
        const value = url.searchParams.get('page')
        const requestedPage = Number(value)
        page = 1
        if (value && /^\d+$/.test(value) && Number.isInteger(requestedPage) && requestedPage > 0) {
          page = Math.min(requestedPage, totalPages)
        }
        update()

        if (value !== null && value !== String(page)) {
          url.searchParams.set('page', String(page))
          window.history.replaceState(window.history.state, '', url)
        }
      }

      root.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return
        const showLess = event.target.closest(selectors.lessButton)
        const showMore = event.target.closest(selectors.button)
        if (!showLess && !showMore) return
        if ((showLess && page <= 1) || (showMore && page >= totalPages)) return

        const firstNewCard = cards[page * pageSize]
        page += showLess ? -1 : 1
        const url = new URL(window.location.href)
        url.searchParams.set('page', String(page))
        window.history.pushState(window.history.state, '', url)
        update()
        if (showLess) {
          const control = page > 1 ? lessButton : button
          control?.focus({ preventScroll: true })
          const lastVisibleCard = cards[Math.min(page * pageSize, cards.length) - 1]
          lastVisibleCard?.scrollIntoView({ block: 'end', inline: 'nearest' })
        } else {
          firstNewCard?.focus({ preventScroll: true })
        }
      })

      window.addEventListener('popstate', restorePage)
      restorePage()
    })
  },
}

export default ArticlesLoadMore
